import React from "react";
import { useModal } from "react-modal-hook";
import {
  CommonModal,
  type CommonModalComponentProps,
} from "../components/Common/CommonModal";
import Modal from "../components/Common/Modal";
import { Body } from "../components/Common/Typography";

export function useConfirmDestructiveAction({
  onConfirm,
  onCancel,
  content,
  ...modalProps
}: Omit<CommonModalComponentProps, "onSubmit" | "onCancel"> & {
  onConfirm: (hideModal: () => void) => unknown;
  onCancel?: (hideModal: () => void) => unknown;
}) {
  function _onCancel() {
    if (onCancel) {
      onCancel(hideConfirmation);
    } else {
      hideConfirmation();
    }
  }

  function onSubmit() {
    onConfirm(hideConfirmation);
  }

  const [showConfirmation, hideConfirmation] = useModal(() => {
    return (
      <Modal onRequestClose={_onCancel}>
        <CommonModal
          content={
            typeof content === "string" ?
              <Body size="large" type="regular">
                {content}
              </Body>
            : content
          }
          onCancel={_onCancel}
          onSubmit={onSubmit}
          height="full"
          size="small"
          primaryButtonText="Delete"
          variant="destructive"
          {...modalProps}
        />
      </Modal>
    );
  }, [onConfirm, onCancel, content, ...Object.values(modalProps)]);

  return showConfirmation;
}
